export default __webpack_public_path__ + "static/GT-America-Extended-Regular-a14998eb2aecf8a0843088e23f967ce1.woff2";